import React from "react";
import { Box, Container, Typography, Paper } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ChooseUnitType = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Container
      component="main"
      maxWidth="xl"
      sx={{
        display: "flex",
      }}
    >
      <Paper
        variant="outlined"
        sx={{
          p: { xs: 2, md: 3 },

          width: "100%",
          minHeight: { xs: "80vh", sm: "65vh" },
          margin: "30px",
          display: "flex",
          "flex-direction": "column",

          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: "32px", sm: "44px" },
            marginTop: { xs: "5px", sm: "25px" },
          }}
        >
          {t("hydraChooseUnit.title")}
        </Typography>
        <Box
          sx={{
            display: { sm: "flex" },
            flexDirection: "row",
            alignItems: "center",
            position: "relative",

            top: { xs: "5%", sm: "15%", md: "25%" },
            gap: "55px",
          }}
        >
          <Box
            sx={{
              border: "1px solid grey",
              padding: "15px",
              borderRadius: "5px",
              width: { xs: "100%", sm: "50%" },
              height: { sm: "100%" },
              boxShadow: "3px 3px 4px 0px #555",
              marginBottom: { xs: "25px", sm: "0" },
              transition: "all 0.4s",
              cursor: "pointer",
              "&:hover": { transform: "scale(1.04)" },
            }}
          >
            <Typography
              onClick={() => {
                navigate("/create-project/configurator", { replace: true });
              }}
              sx={{ fontSize: { xs: "16px", md: "20px" } }}
            >
              <div
                style={{
                  fontSize: "22px",
                  fontWeight: "600",
                  textAlign: "center",
                }}
              >
                COMPACT | pro
              </div>{" "}
              {t("hydraChooseUnit.text")}
            </Typography>
          </Box>

          <Box
            sx={{
              border: "1px solid grey",
              padding: "15px",
              borderRadius: "5px",
              width: { xs: "100%", sm: "50%" },
              height: { sm: "100%" },
              cursor: "pointer",
              boxShadow: "3px 3px 4px 0px #555",
              transition: "all 0.4s",
              position: "relative",

              "&:hover": { transform: "scale(1.04)" },
            }}
          >
            <Typography
              onClick={() => {
                navigate("/hydra", { replace: true });
              }}
              sx={{ fontSize: { xs: "16px", md: "20px" }, textAlign: "center" }}
            >
              <div
                style={{
                  fontSize: "22px",
                  fontWeight: "600",
                  textAlign: "center",
                }}
              >
                HYDRA | pro
              </div>{" "}
              {t("hydraChooseUnit.text1")}
            </Typography>
            <div
              style={{
                fontSize: "12px",
                width: "100px",
                fontWeight: "300",
                textAlign: "center",
                position: "absolute",
                bottom: 0,
                right: 0,
                backgroundColor: theme.palette.secondary.main,
                borderRadius: "5%",
              }}
            >
              BETA FEATURE
            </div>{" "}
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default ChooseUnitType;
